import posthtml from 'posthtml/lib';
import { addInfoComponents } from './utils';
export const addSiteInfo = (mjml, options, t) => {
  const siteInfo = tree => {
    const siteInfoComponent = {
      tag: 'mj-section',
      attrs: {
        padding: '18px 0px',
        'background-color': '#fff',
        'css-class': 'site-info-section',
        'full-width': 'full-width'
      },
      content: [{
        tag: 'mj-column',
        attrs: {
          width: '100%'
        },
        content: addInfoComponents(options, t)
      }]
    };
    tree.match({
      tag: 'mj-body'
    }, node => {
      node.content.push(siteInfoComponent);
      return node;
    });
  };
  const withSiteInfo = posthtml([siteInfo]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withSiteInfo.html;
};
//# sourceMappingURL=add-site-info.js.map